import Constants from "../utils/consts";
import Cookies from "universal-cookie";

const REQUEST_TIMEOUT = 600000; // 10 minuti

function getDbName() {
  try {
    return new Cookies().get("db", { path: "/" });
  } catch (error) {
    console.warn("[addEvento] Impossibile leggere il cookie db:", error);
    return undefined;
  }
}

export default async function addEvento(
  uname,
  token,
  evento,
  userId,
  onProgress,
) {
  return new Promise((resolve, reject) => {
    const db = getDbName();
    const endpoint = `${Constants.mainUrl}addEvento.php`;

    const xhr = new XMLHttpRequest();
    xhr.timeout = REQUEST_TIMEOUT;

    // Progress tracking
    xhr.upload.onprogress = function(event) {
      if (event.lengthComputable && onProgress) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        onProgress(percentComplete);
      }
    };

    xhr.onload = function() {
      console.log("[addEvento] response status:", xhr.status);
      console.log("[addEvento] response body:", xhr.responseText);

      if (xhr.status === 200) {
        try {
          const response = JSON.parse(xhr.responseText);
          resolve(response);
        } catch (error) {
          console.error("[addEvento] Error parsing response:", error);
          reject({
            error: "PARSE_ERROR",
            message: "Risposta del server non valida",
            details: xhr.responseText,
          });
        }
      } else {
        reject({
          error: "HTTP_ERROR",
          status: xhr.status,
          message: "Errore dal server durante il caricamento",
          details: xhr.responseText,
        });
      }
    };

    xhr.onerror = function(event) {
      console.error("[addEvento] network error:", event);
      reject({
        error: "NETWORK_ERROR",
        message: "Errore di rete durante l'upload",
      });
    };

    xhr.ontimeout = function() {
      console.error(
        "[addEvento] timeout - Il caricamento ha superato il tempo massimo",
      );
      reject({
        error: "TIMEOUT",
        message:
          "Il caricamento dell'evento ha richiesto troppo tempo. Riprova più tardi.",
      });
    };

    xhr.onabort = function() {
      console.warn("[addEvento] upload abortito dall'utente");
      reject({
        error: "ABORTED",
        message: "Upload annullato",
      });
    };

    // Prepara i dati come JSON (più affidabile di FormData per base64)
    const payload = {
      token: token,
      uname: uname,
      db_name: db || undefined,
      titolo: evento.titolo || "",
      descrizione: evento.descrizione || "",
      link_1: evento.link1 || "",
      link_2: evento.link2 || "",
      titolo_l1: evento.titolo_l1 || "",
      titolo_l2: evento.titolo_l2 || "",
      locandina: evento.locandina || "",
      allegato:
        evento.allegato && evento.allegato !== "" ? evento.allegato : "",
      allegato_nome: evento.allegato_nome || "",
      data: evento.data || "",
      partecipanti: evento.partecipanti || "0",
      orario: evento.orario || "",
      orario_fine: evento.orarioFine || "",
      user_id: userId,
    };

    console.log("[addEvento] sending data:", {
      token: token ? "presente" : "mancante",
      uname,
      titolo: evento.titolo,
      hasLocandina: !!(evento.locandina && evento.locandina.length > 0),
      locandinaSize: evento.locandina ? evento.locandina.length : 0,
      hasAllegato: !!evento.allegato,
    });

    if (onProgress) {
      onProgress(0);
    }

    xhr.open("POST", endpoint, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(payload));
  });
}
